import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import DepositStart from './start';
import ClientTransactionSuccess from '../components/success';
import { depositSearchPlayer, depositSuccessState } from '../constants';
import { browserHistory } from '@common/helpers/browserHistory';
import ClientTransactionSearchPlayer from '../components/searchPlayer';
import { FinishCollectDepositMoney } from '@app/dev/actions/clientTransaction';

const ClientTransactionDeposit = () => {
  const [client, setClient] = useState(null);
  const [maxDepositAmount, setMaxDepositAmount] = useState(0);
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch()

  if (success) {
    return (
      <ClientTransactionSuccess
        {...depositSuccessState}
        onReset={() => browserHistory.push('/clientTransaction')}
      />
    );
  }

  if (!client) {
    return (
      <ClientTransactionSearchPlayer
        {...depositSearchPlayer}
        onNext={result => {
          setClient(result.playerInfo)
          setMaxDepositAmount(result.maxDepositAmount)
        }}
      />
    );
  }

  const onFinish = () => {
    setSuccess(true)
    dispatch(FinishCollectDepositMoney())
  }

  const onBack = () => {
    setClient(null);
    setMaxDepositAmount(0);
    dispatch(FinishCollectDepositMoney())
  }

  return (
    <DepositStart
      client={client}
      onBack={onBack}
      onNext={onFinish}
      maxDepositAmount={maxDepositAmount}
    />
  );
};

export default ClientTransactionDeposit;
